<script>
export default {
  name: "IndexedList",

  props: {
    startCountWith: {
      type: String,
      default: "1"
    },
    bold: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    let liCounter = 1;

    this.$slots.default.forEach((node) => {
      if (node.elm.nodeName === 'LI') {
        node.elm.dataset.index = this.startCountWith + '.' + liCounter;
        liCounter++;
      }
    });
  }
}
</script>

<template>
 <ol class="indexed-list" :class="{'bold-li': bold}">
   <slot></slot>
 </ol>
</template>

<style scoped lang="scss">
.indexed-list {
  list-style: none;
  padding-left: 0;

  ol {
    margin-left: 40px;
  }
}

.indexed-list > li {
  margin: 15px 0;

  &::before {
    padding-left: 0;
    content: attr(data-index) " ";
    margin-right: 10px;
    font-weight: 600;
  }
}

.bold-li {
  font-weight: bold;
}
</style>